import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { OnlineStatusComponent } from './online-status.component';

@NgModule({
  declarations: [OnlineStatusComponent],
  imports: [CommonModule, IonicModule],
  exports: [OnlineStatusComponent],
})
export class OnlineStatusModule {}
